/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createResultSet } from '../../factoriesAny.js';
export var ResultSetDependencies = {
  createResultSet: createResultSet
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesResultSet.generated.js
// module id = 647
// module chunks = 0